module.exports = __webpack_public_path__ + "static/fabric-table-dnd-rows-50e97c863365f75faca526fe493da25e.gif";